"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var operation_models_1 = require("../model/operation-models");
var DrawerControlsManagerService = /** @class */ (function () {
    function DrawerControlsManagerService(eventBase) {
        this.eventBase = eventBase;
    }
    DrawerControlsManagerService.prototype.openDocumentEditor = function (attachmentId, fieldId, categoryId, entityId, name, iconInfo) {
        var drawerOperationData = new operation_models_1.DocumentOperationModel(attachmentId, fieldId, categoryId, entityId, name, iconInfo);
        this.eventBase.publish(drawerOperationData.configs.openEventName, drawerOperationData);
        return this.eventBase.listen(drawerOperationData.configs.closeEventName + "-" + drawerOperationData.id);
    };
    DrawerControlsManagerService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_session_data_provider_api_js_1.EventBase])
    ], DrawerControlsManagerService);
    return DrawerControlsManagerService;
}());
exports.DrawerControlsManagerService = DrawerControlsManagerService;
//# sourceMappingURL=drawer-controls-manager.service.js.map